import { 
    task_task_create, 
    task_list_get, 
    task_lists_get, 
    task_taskid_get,
    task_list_getallstatus,
    task_relatedlist_get,
    task_search_get,
    task_task_update, 
    task_chat_create, 
    task_date_get,
    task_remove_taguser,
    get_task_chat, 
    task_task_unread,
    chat_attachment_create,
    reminder_task_upsert,
    reminder_others_upsert,
    get_reminder_status,
    remove_reminder_status,
    remove_reminder2_status,
    remove_reminder3_status,
    reminder_unread_update,
    task_update_subtaskmsg,
    task_self_deadline,
    task_previous_deadline,
    task_update_hide,
    task_checklist_byid,
    task_checklist_insertnew,
    task_checklist_update,
    task_checklist_remove
} from '../../Models/taskmanagement';

//====== ON CREATE TASKS DATA ======
export const onCreateTasks = (data) => {
    return new Promise((resolve, reject) => {
        task_task_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== ON CREATE TASKS DATA ======
export const onUpdateTaskHide = (data) => {
    return new Promise((resolve, reject) => {
        task_update_hide(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//===== ON GET 10 TASKS DATA ========
export const onGetTasks = (data) => {
    return new Promise((resolve, reject) => {
        task_lists_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//===== GET ALL TASKS ======
export const onGetAllTasks = (data) => {
    return new Promise((resolve, reject) => {
        task_list_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//===== GET ALL TASKS ======
export const onGetTaskByID = (data) => {
    return new Promise((resolve, reject) => {
        task_taskid_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetAllTasksAllStatus = (data) => {
    return new Promise((resolve, reject) => {
        task_list_getallstatus(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetTasksByDate = (data) => {
    return new Promise((resolve, reject) => {
        task_date_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetRelatedTasks = (data) => {
    return new Promise((resolve, reject) => {
        task_relatedlist_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetSearchTasks   = (data) => {
    return new Promise((resolve, reject) => {
        task_search_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== ON UPDATE STATUS ======
export const onUpdateTasks = (data) => {
    return new Promise((resolve, reject) => {
        
        task_task_update(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}

//====== ON GET Reminder ======
export const onGetTasksReminder = (data) => {
    return new Promise((resolve, reject) => {
        
        get_reminder_status(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}
//====== ON REMOVE Reminder ======
export const onRemoveTasksReminder = (data) => {
    return new Promise((resolve, reject) => {
        
        remove_reminder_status(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}

export const onRemoveTagUser = (data) => {
    return new Promise((resolve, reject) => {
        
        task_remove_taguser(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}

export const onRemoveTasksReminder2 = (data) => {
    return new Promise((resolve, reject) => {
        
        remove_reminder2_status(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}

export const onRemoveTasksReminder3 = (data) => {
    return new Promise((resolve, reject) => {
        
        console.log('onRemoveTasksReminder3 , ',data)
        remove_reminder3_status(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}
//====== ON UPDATE Reminder ======
export const onUpdateTasksReminder = (data) => {
    return new Promise((resolve, reject) => {
        
        reminder_task_upsert(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}
//====== ON UPDATE Reminder ======
export const onUpdateOthersReminder = (data) => {
    return new Promise((resolve, reject) => {
        
        reminder_others_upsert(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}

//====== ON UPDATE Reminder Unread ======
export const onUpdateReminderUnread = (data) => {
    return new Promise((resolve, reject) => {
        
        reminder_unread_update(data)
        .then((response) => response.json())
        .then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
        
    });
}

//======= UNREAD TASK =======
export const onUpdateUnreadTasks = (data) => {
    return new Promise((resolve, reject) => {
        task_task_unread(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}

//======= UNREAD SUBTASK =======
export const onUpdateSubTaskMsg = (data) => {
    return new Promise((resolve, reject) => {
        task_update_subtaskmsg(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}

//======== CHAT ========
export const onCreateChat = (data) => {
    return new Promise((resolve, reject) => {
        task_chat_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetChat = (data) => {
    return new Promise((resolve, reject) => {
        get_task_chat(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onSelfTaskDeadline = (data) => {
    return new Promise((resolve, reject) => {
        task_self_deadline(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onSelfPreviousTaskDeadline = (data) => {
    return new Promise((resolve, reject) => {
        task_previous_deadline(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetChecklistByid = (data) => {
    return new Promise((resolve, reject) => {
        task_checklist_byid(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onInsertNewChecklistByid = (data) => {
    return new Promise((resolve, reject) => {
        task_checklist_insertnew(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onRemoveChecklistByid = (data) => {
    return new Promise((resolve, reject) => {
        task_checklist_remove(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onUpdateChecklistByid = (data) => {
    return new Promise((resolve, reject) => {
        task_checklist_update(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======== ATTACHMENT =======
export const onCreateAttachment = (data) => {
    return new Promise((resolve, reject) => {
        chat_attachment_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}